import { computed, onMounted, ref } from 'vue';

const MIN_PRELOADER_ANIMATION_CYCLES = 1;

export const usePreloader = () => {
    const isPageLoaded = ref(false);
    const completedAnimationCycles = ref(0);

    const isPreloaderAnimationFinished = computed(() => {
        return completedAnimationCycles.value >= MIN_PRELOADER_ANIMATION_CYCLES;
    });

    const isPreloaderVisible = computed(() => {
        return !isPageLoaded.value || !isPreloaderAnimationFinished.value;
    });

    const finishPreloaderAnimation = () => {
        completedAnimationCycles.value += 1;
    };

    onMounted(() => {
        if (document.readyState === 'complete') {
            isPageLoaded.value = true;

            return;
        }

        window.addEventListener('load', () => {
            isPageLoaded.value = true;
        }, { once: true });
    });

    return {
        isPreloaderVisible,
        finishPreloaderAnimation,
    };
};
